<template>
    <div class="container fixedHeight">
        <textarea v-model="internalText" :class="['form-control', 'rounded-0', 'col-12', {'border-danger': errorStyle}]" :rows="rows" readonly="true"></textarea>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueClipboard from 'vue-clipboard2';    

    Vue.use(VueClipboard);

    export default {
        props: {
            lines: {
                type: Array,
                default: []            
            },
            text: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: "Enrollment Confirmation"
            },
            errorStyle: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            rows() {
                return this.lines.length < 10 ? 10 : this.lines.length;
            },
            buttons() { 
                return []; 
            },
            buttonsCustom() {

                return [
                    {  
                        name: "*I want to enter more enrollments",
                        onClick: () => {return false;}
                    },
                    {
                        name: "Participant enrollment complete",
                        onClick: async () => {return true;}
                    }]
            },
            internalText() {
                return this.lines.join('\n') || this.text
            }
        },
        created() {
        },
    }
</script>

<style lang="scss" scoped>
    .fixedHeight{
        overflow-y: scroll;
        max-height: 500px; 
    }
</style>



// WEBPACK FOOTER //
// src/action-items/types/EnrollmentConfirmation.vue